// Promise-based concurrency limiter (no dependencies).
//
// acquire() resolves with a one-shot release function once a slot is free.
// run(task) holds a slot for the lifetime of the task, releasing it on both
// success and failure so the queue can never get stuck.
export function createLimiter (limit) {
  if (!Number.isInteger(limit) || limit < 1) {
    throw new RangeError('createLimiter: limit must be a positive integer')
  }
  let active = 0
  const queue = []

  const next = () => {
    while (active < limit && queue.length) {
      active++
      let released = false
      const release = () => {
        if (released) return
        released = true
        active--
        next()
      }
      queue.shift()(release)
    }
  }

  const acquire = () => new Promise(resolve => {
    queue.push(resolve)
    next()
  })

  const run = async task => {
    const release = await acquire()
    try {
      return await task()
    } finally {
      release()
    }
  }

  return { acquire, run }
}
